// Module
var code = "<h3>Advisor Groups</h3> <div class=\"listingTableContainer\"> <table id=\"advisorGroupsTable\"> <thead id=\"advisorGroupsTableHead\"></thead> <tbody id=\"advisorGroupsTableBody\"></tbody> </table> </div> ";
// Exports
export default code;